import React, { Component } from 'react';
// import { Provider } from 'mobx-react';
import {BrowserRouter} from "react-router-dom";
/*import { socketConn } from './utils/utils';
import stores from './stores/index';*/
import Routes from './routes/index';
// import './api/resInterceptors';
import './App.less';

class App  extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes/>
      </BrowserRouter>
    )
  }
}

export default App;
